import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import { Logo } from "@/components/Brand";
import api, { apiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (e2) { setErr(apiError(e2)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-[calc(100vh-140px)] flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md bg-white border border-gray-100 rounded-3xl shadow-card p-8">
        <div className="flex justify-center mb-6"><Logo size="text-3xl" /></div>
        {sent ? (
          <div className="text-center" data-testid="forgot-sent">
            <MailCheck className="mx-auto text-green-500" size={40} />
            <h1 className="font-heading font-extrabold text-2xl mt-3">Check your email</h1>
            <p className="text-sm text-muted-foreground mt-1">If an account exists for <strong>{email}</strong>, we've sent a link to reset your password. The link expires in 1 hour.</p>
            <Link to="/login" className="inline-block mt-5 bg-metros-red text-white rounded-full px-6 py-3 font-semibold">Back to Sign In</Link>
          </div>
        ) : (
          <>
            <h1 className="font-heading font-extrabold text-2xl text-center">Forgot password?</h1>
            <p className="text-sm text-muted-foreground text-center mb-6">Enter your email and we'll send you a reset link.</p>
            {err && <div className="bg-red-50 text-metros-red text-sm rounded-xl px-4 py-3 mb-4">{err}</div>}
            <form onSubmit={submit} className="space-y-4">
              <input data-testid="forgot-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-gray-200 px-4 py-3 focus:ring-2 focus:ring-metros-red focus:outline-none" />
              <button data-testid="forgot-submit" disabled={busy} className="w-full bg-metros-red hover:bg-metros-redhover text-white rounded-full py-3.5 font-bold flex justify-center items-center gap-2 disabled:opacity-60">
                {busy && <Loader2 className="animate-spin" size={18} />} Send Reset Link
              </button>
            </form>
            <p className="text-sm text-center mt-5"><Link to="/login" className="text-metros-red font-semibold">Back to Sign In</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
